import { render, staticRenderFns } from "./VoteList.vue?vue&type=template&id=120a3ada&scoped=true&"
import script from "./VoteList.vue?vue&type=script&lang=ts&"
export * from "./VoteList.vue?vue&type=script&lang=ts&"
import style0 from "./VoteList.vue?vue&type=style&index=0&id=120a3ada&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120a3ada",
  null
  
)

export default component.exports